<template>
  <div v-show="show" class="pre-export-component-template">
    <div class="bro-check-body">
      <p class="bro-check-header">{{ $t('preExport.NEN5104Normalization.label.header') }}</p>
      <p class="bro-check-explanation">{{ $t('preExport.NEN5104Normalization.label.explanation') }}</p>

      <div class="normalization-toggle">
        <DxSwitch :value="normalizeLayerDescriptions" @value-changed="setNormalization($event.value)" />
        <label>{{ $t('preExport.NEN5104Normalization.label.toggle') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/less/colors.less'

import { DxSwitch } from 'devextreme-vue/switch'

export default {
  name: 'NEN5104Normalization',
  data() {
    return {
      normalizeLayerDescriptions: false,
      show: true
    }
  },
  props: {
    projectId: {
      type: String,
      required: true
    }
  },
  components: {
    DxSwitch
  },
  computed: {
    getExportProjects() {
      return this.$store.getters.getExportInformationExportProjects
    }
  },
  mounted() {
    this.$emit('preExportCheckUpdated')

    // Seed the conversion context, so the export always carries an explicit value. Reuse an
    // earlier choice, because stepping back and forth through the export screens remounts us.
    const exportProject = this.getExportProjects.find(project => project.PrID === this.projectId)
    this.setNormalization(exportProject?.conversionContext?.nen5104NormalizationOfLayerDescriptions ?? this.normalizeLayerDescriptions)
  },
  methods: {
    setNormalization(value) {
      this.normalizeLayerDescriptions = value
      this.$store.commit('updateExportProjectConversionContext', { PrID: this.projectId, conversionContext: { nen5104NormalizationOfLayerDescriptions: value } })
    }
  }
}
</script>

<style lang="less" scoped>
.pre-export-component-template {
  background: @gray100;
  padding: 16px;
}
.normalization-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  color: @gray900;
  font-size: 14px;
  line-height: 20px;
}
</style>
